import { redirect } from "@tanstack/react-router";
import { HOME_PATH } from "@/components/shell/nav";

/** `beforeLoad` of a route that is locked for the MVP: typing its address lands on the landing page, Agent Rocket. */
export function redirectToHome(): never {
  throw redirect({ to: HOME_PATH });
}
